// extracted by mini-css-extract-plugin
export default {"overlay":"LevelUpModal_overlay__aTSF5","container":"LevelUpModal_container__DBSth"};